import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { servicoService } from '@/services/servico.service'
import type { Servico, ServicoPlano, ServicoAdicional } from '@/types/database'
import type { ListFilters } from '@/services/associado.service'

export function useServicos(filters: ListFilters = {}) {
    return useQuery({
        queryKey: ['servicos', filters],
        queryFn: () => servicoService.list(filters),
    })
}

export function useAllServicos() {
    return useQuery({
        queryKey: ['servicos', 'all'],
        queryFn: () => servicoService.getAll(),
    })
}

export function useCreateServico() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (input: Partial<Servico>) => servicoService.create(input),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['servicos'] }),
    })
}

export function useUpdateServico() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: ({ id, ...input }: Partial<Servico> & { id: string }) => servicoService.update(id, input),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['servicos'] }),
    })
}

export function useDeleteServico() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (id: string) => servicoService.remove(id),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['servicos'] }),
    })
}

/* ── Planos ── */
export function useUpsertPlano() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (input: Partial<ServicoPlano>) => servicoService.upsertPlano(input),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['servicos'] }),
    })
}

export function useDeletePlano() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (id: string) => servicoService.deletePlano(id),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['servicos'] }),
    })
}

/* ── Adicionais ── */
export function useUpsertAdicional() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (input: Partial<ServicoAdicional>) => servicoService.upsertAdicional(input),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['servicos'] }),
    })
}

export function useDeleteAdicional() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (id: string) => servicoService.deleteAdicional(id),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['servicos'] }),
    })
}
